(() => {
    "use strict";

    /**
     * Rastreamento adiado. Os scripts do admin (GTM, GA4, Ads…) vêm em `<template data-tracking>` e só são
     * ativados na primeira interação do visitante (rolagem da página, toque, clique, tecla, mouse) ou, se nada
     * acontecer, após TRACKING_DEFER_MS. Somados, eles passavam de 1,5 s de bloqueio da thread principal no
     * mobile, o que derrubava o Lighthouse sem trazer nada para a primeira renderização.
     *
     * Eventos empurrados ao `dataLayer` antes do carregamento ficam na fila e o GTM os processa ao iniciar;
     * conversões (envio de formulário, WhatsApp) acontecem depois de uma interação, com o GTM já carregado.
     */
    const TRACKING_DEFER_MS = 6000;
    const EVENTS = ["pointerdown", "pointermove", "keydown", "scroll", "touchstart", "wheel"];
    let loaded = false;
    let timer = 0;

    function activate(node, target) {
        if (node.nodeName === "SCRIPT") {
            const script = document.createElement("script");
            Array.from(node.attributes).forEach((attr) => script.setAttribute(attr.name, attr.value));
            script.text = node.textContent;
            target.appendChild(script);
            return;
        }
        target.appendChild(node.cloneNode(true));
    }

    /** `scroll` em fase de captura também chega de rolagens internas (carrosséis, snap inicial): só conta a da página. */
    function onInteraction(event) {
        if (event.type === "scroll" && event.target !== document) {
            return;
        }
        load();
    }

    function load() {
        if (loaded) {
            return;
        }
        loaded = true;
        window.clearTimeout(timer);
        EVENTS.forEach((type) => window.removeEventListener(type, onInteraction, true));
        document.querySelectorAll("template[data-tracking]").forEach((template) => {
            const target = template.dataset.tracking === "head" ? document.head : document.body;
            Array.from(template.content.childNodes).forEach((node) => activate(node, target));
            template.remove();
        });
    }

    window.Site = window.Site || {};
    window.Site.loadTracking = load;

    EVENTS.forEach((type) => window.addEventListener(type, onInteraction, { capture: true, passive: true }));
    if (document.readyState === "complete") {
        timer = window.setTimeout(load, TRACKING_DEFER_MS);
    } else {
        window.addEventListener("load", () => {
            timer = window.setTimeout(load, TRACKING_DEFER_MS);
        }, { once: true });
    }
})();
